import request from "@/utils/request";
import { httpAxios, httpAuthAxios } from "./request";

export function loginByUsername(username, password) {
  const data = {
    username,
    password,
  };
  return request({
    url: "/login/login",
    method: "post",
    data,
  });
}

export function logout() {
  return request({
    url: "/login/logout",
    method: "post",
  });
}

export function getUserInfo(token) {
  return request({
    url: "/user/info",
    method: "get",
    params: { token },
  });
}

export function getSmsCode(account) {
  return httpAxios({
    url: "/v1/backendOperatorRpc/getSmsCode",
    method: "post",
    data: { account },
  });
}
